import { useQuestion } from '.';
import type { IQuestion, IQuestionReply } from '../../types';
import { useAuthUser } from '../authUser';
import { useCurrentUser } from '../user';

export interface QuestionPermissions {
	canDelete: boolean;
	canEdit: boolean;
	canReact: boolean;
	canReply: boolean;
	canAccept: boolean;
}

export function useQuestionPermissions(
	entity: IQuestion | IQuestionReply,
	type: 'question' | 'reply' = 'reply'
): QuestionPermissions {
	const { user, isAdminUser, isEditorOrAdminUser } = useAuthUser();
	const { data: currentUser } = useCurrentUser();
	const userPermissions = currentUser?.permissions;
	const customPermissions = {
		canDelete: userPermissions?.some(
			(permission) => permission === 'Questions.Delete'
		),
		canEdit: userPermissions?.some(
			(permission) => permission === 'Questions.Update'
		),
	};

	const { data: questionEntity } = useQuestion({
		id: type === 'reply' ? entity.parent! : entity.id,
	});

	const isOwner = entity?.owners.includes(user.id);
	const isQuestionOwner = questionEntity?.owners.includes(user.id);
	const isAssignedTo = entity?.assigned_to === user.id;

	return {
		canDelete: isAdminUser || isOwner || !!customPermissions.canDelete,
		canEdit: isAdminUser || isOwner || !!customPermissions.canEdit,
		canReact: true,
		canReply: true,
		canAccept:
			isEditorOrAdminUser ||
			isAssignedTo ||
			!!isQuestionOwner ||
			!!customPermissions.canEdit,
	};
}
